var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('transition',{attrs:{"appear":"","enter-active-class":"animate__animated animate__fadeInLeft","leave-active-class":"animate__animated animate__fadeOutRight"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }